import { EyeOutlined } from '@ant-design/icons';
import { THEME } from '@common/constants/theme.constant';
import { Button } from '@common/general-ui/button/button.component';
import { Collapse, CollapsePanel } from '@common/general-ui/collapse/collapse.component';
import { Icon } from '@common/general-ui/icon/icon.component';
import { t } from '@common/hooks/use-t.hook';
import { Popover } from 'antd';
import React from 'react';
import { css } from 'twin.macro';
const ReactJsonInternal = require('react-json-view').default;

interface IProps {
    json: unknown;
    collapsed_json?: number | boolean;
    className?: string;
}

export const JsonPreview = ({ json, className, collapsed_json = 1 }: IProps): JSX.Element | null => {
    return (
        <div className={className}>
            <Popover
                trigger="click"
                content={
                    <div css={styles.insidePopover}>
                        <ReactJson json={json} collapsed_json={collapsed_json} />
                    </div>
                }
                title={t('Title')}
            >
                <Button name="view" variant="empty" tw="w-min py-0">
                    <Icon icon={EyeOutlined} css={styles.icon} />
                </Button>
            </Popover>
        </div>
    );
};

export const ReactJson = ({ json, collapsed_json = 1 }: IProps): JSX.Element | null => {
    return (
        <div css={styles.insidePopover}>
            <ReactJsonInternal src={json} displayDataTypes={false} collapsed={collapsed_json} />
        </div>
    );
};

export const InlineJsonPreview = ({ json, collapsed_json }: IProps): JSX.Element | null => {
    return (
        <div tw="relative">
            <div css={styles.inline}>
                <Collapse>
                    <CollapsePanel key={'1'} header={''}>
                        <div css={styles.insidePopover}>
                            <ReactJson json={json} collapsed_json={collapsed_json} />
                        </div>
                    </CollapsePanel>
                </Collapse>
            </div>
        </div>
    );
};

const styles = {
    icon: css`
        svg {
            width: 24px;
            height: 18px;
            && path {
                font-size: 30px;
            }
        }
    `,
    insidePopover: css`
        font-size: 14px;
        line-height: 16px;
    `,
    inline: css`
        position: absolute;
        z-index: 9999;

        && .ant-collapse-header,
        && .ant-collapse-content-box,
        && .ant-collapse-panel {
            padding: 0px;
        }

        && .ant-collapse {
            border: 0px;
            background: transparent;
            margin: 0;
        }
        && .ant-collapse-item {
            border-bottom: 0;
        }

        && .ant-collapse-header.ant-collapse-header {
            background: white;
            color: ${THEME.GRAY};
        }
        && .ant-collapse-arrow {
            padding: 8px;
            z-index: 1;
            background: white;
            border: 1px solid red;
            position: relative;
            margin-right: 0 !important;
        }

        && .ant-collapse-content-box {
            padding: 4px;
            box-shadow: 1px 1px 10px rgb(0 0 0 / 0.2);
            -webkit-box-shadow: 1px 1px 10px rgb(0 0 0 / 0.2);
            border: 1px solid ${THEME.GRAY};
            z-index: 1;
            position: relative;
            background: white;
        }
    `,
};
